export default "__VITE_ASSET__5W27qYH4__"